/**
 * HTTP service layer for the Analytics Reports module.
 * Each function maps 1-to-1 to a backend endpoint and returns the raw Axios promise.
 * Auth headers and the base URL are injected by B2B_API_INSTANCE — do not add them here.
 * Consumed exclusively by reportsAction.ts (Redux thunks); do not call these directly from components.
 */
import { B2B_API_INSTANCE } from "../index";

// Bump SERVICE_VERSION when the backend promotes the API to a new major version.
const SERVICE_VERSION: number = 1;
const ADMIN_REPORTS_CONTROLLER_NAME: string = `/analytic-svc/api/v${SERVICE_VERSION}/Reports`;

// API 1: Company summary table, top cards, and latest month graph data
export const getCompaniesDistribution = () => {
  return B2B_API_INSTANCE.get(`${ADMIN_REPORTS_CONTROLLER_NAME}/GetCompaniesDistribution`);
};

// API 2: Contract accounts list and their charges per company
export const getAccountsChargeDistribution = () => {
  return B2B_API_INSTANCE.get(`${ADMIN_REPORTS_CONTROLLER_NAME}/GetAccountsChargeDistribution`);
};

// APIs 3–5 accept a date range as YYYYMMDD strings (e.g. '20260101', '20260630').
// The caller (reportsAction.ts) is responsible for formatting dates before passing them here.

// API 3: Payment distribution breakdown (myTNBiz vs Others), filtered by date range
export const getPaymentsDistribution = (startDate: string, endDate: string) => {
  return B2B_API_INSTANCE.post(`${ADMIN_REPORTS_CONTROLLER_NAME}/GetPaymentsDistribution`, { startDate, endDate });
};

// API 4: Monthly bills vs payments comparison, filtered by date range
export const getBillsPaymentDistribution = (startDate: string, endDate: string) => {
  return B2B_API_INSTANCE.post(`${ADMIN_REPORTS_CONTROLLER_NAME}/GetBillsPaymentDistribution`, { startDate, endDate });
};

// API 5: Payment channel distribution treemap (e.g. myTNB Portal, JomPAY, EFT), filtered by date range
export const getPaymentsChannelDistribution = (startDate: string, endDate: string) => {
  return B2B_API_INSTANCE.post(`${ADMIN_REPORTS_CONTROLLER_NAME}/GetPaymentsChannelDistribution`, { startDate, endDate });
};